import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import es from "./es.json";
import us from "./us.json";
import pt from "./pt.json";
import pl from "./pl.json";
import sk from "./sk.json";
import fr from "./fr.json";
import it from "./it.json";

const savedLanguage = sessionStorage.getItem("languageCode") || "us";

const resources = {
  us: {
    translation: us,
  },
  es: {
    translation: es,
  },
  pt: {
    translation: pt,
  },
  fr: {
    translation: fr,
  },
  pl: {
    transalation: pl,
  },
  sk: {
    translation: sk,
  },
  it: {
    translation: it,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "us",
  lng: savedLanguage,

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
